import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { withTranslation } from 'react-i18next';

import logoWhite from "../assets/img/logo-white.svg";
import favicon from '../assets/img/favicon.png';
import space from '../assets/img/space.jpg';
import lockGrey from "../assets/img/lockGrey.png";

import '../assets/css/bootstrap.min.css';
import '../assets/css/app.css';
import '../assets/css/fonts.css';

import Footer from './Footer';
import FileNotFound from './FileNotFound';
import RightSide from './RightSide';
import EmailProtectFragment from './EmailProtectFragment';
import BadBrowser from './BadBrowser';
import UserNotFound from './UserNotFound';

import "../assets/css/deposit.scss"

import { gup, checkDeviceAndBrowser, checkFileType } from '../utils/utils';

let BASE_URL;

if (/localhost/.test(window.location.host)) {
    BASE_URL = 'https://api.staging.lockself.com';
}
else {
    BASE_URL = window.location.origin;
}
class EmailProtectFragmentStart extends Component {
    constructor(props) {
        super(props)

        this.state = {
            allIsGood: null,
            isAvailable: null,
            name: "",
            status: null,
            size: "",
            sizeBytes: "",
            token: "",
            tokenSent: false,
            transferHash1: gup('hash1'),
            transferHash2: gup('hash2'),
            userEmail: "",
            userExternalEmail: "",
            userFname: "",
            userHash1: gup('uh1'),
            userHash2: gup('uh2'),
            userLname: "",
            whitemarkBackground: "",
            whitemarkBtnColor: "",
            whitemarkFavicon: "",
            whitemarkLogo: "",
            whitemarkTitle: "",
            badBrowser: false,
            id: null,
        }
    }

    async getWhitemark() {
        await fetch(`${BASE_URL}/api/external/transfers/whitemark?hash1=${this.state.transferHash1}&hash2=${this.state.transferHash2}`)
            .then((res) => {
                //console.log("RESPONSE1 = ", res)
                return res.json();
            }).then(res => {
                //console.log("DATA1 = ", res);
                this.setState({
                    whitemarkBackground: res["whitemarkBackground"] ? "data:image/png;base64," + res["whitemarkBackground"] : space,
                    whitemarkBtnColor: res["whitemarkBtnColor"] ? "#" + res["whitemarkBtnColor"] : "#f47532",
                    whitemarkFavicon: res["whitemarkFavicon"] ? "data:image/svg+xml;base64," + res["whitemarkFavicon"] : favicon,
                    whitemarkLogo: res["whitemarkLogo"] ? "data:image/svg+xml;base64," + res["whitemarkLogo"] : logoWhite,
                    whitemarkTitle: res["whitemarkTitle"] ? res["whitemarkTitle"] : "LockSelf Files Transfer"
                });
            })
            .catch((error) => {
                console.log("ERROR1 = ", error)
                this.setState({
                    isAvailable: false,
                    whitemarkBackground: space,
                    whitemarkBtnColor: "#f47532",
                    whitemarkFavicon: favicon,
                    whitemarkLogo: logoWhite,
                    whitemarkTitle: "LockSelf Files Transfer"
                });
            });
    }

    async getInfo() {
        let resStatus = 0;
        await fetch(`${BASE_URL}/api/external/transfers/email/info?hash1=${this.state.transferHash1}&hash2=${this.state.transferHash2}&uh1=${this.state.userHash1}&uh2=${this.state.userHash2}`)
            .then((res) => {
                //console.log("RESPONSE2 = ", res)
                resStatus = res.ok;
                this.setState({
                    status: res.status
                })
                return res.json();
            }).then((res) => {
                //console.log("DATA2 = ", res)
                //console.log("DATA2 - STATUS = ", resStatus);
                if (resStatus) {
                    this.setState({
                        isAvailable: true,
                        name: res.name,
                        size: res.size,
                        token: res.token,
                        userEmail: res.email,
                        userFname: res.fname,
                        userLname: res.lname,
                        userExternalEmail: res.externalEmail,
                        linked: res.transferLinked,
                        id: res.id
                    });
                } else {
                    this.setState({
                        isAvailable: false
                    })
                }
            })
            .catch((error) => {
                console.log("ERROR2 = ", error)
                this.setState({
                    isAvailable: false,
                });
            });
    }

    async componentDidMount() {
        await checkDeviceAndBrowser().then(res => this.state.badBrowser = !res)
        await this.getWhitemark();
        checkDeviceAndBrowser();
        await this.getInfo();
    }

    generateToken = async () => {
        await fetch(`${BASE_URL}/api/external/transfers/email/token?hash1=${this.state.transferHash1}&hash2=${this.state.transferHash2}&uh1=${this.state.userHash1}&uh2=${this.state.userHash2}&sendEmail=${this.state.linked?.length ? 2 : 1}`)
            .then((res) => {
                this.setState({
                    status: res.status
                })
            })
            .catch((err) => {
                console.log("error : ", err)
            })
    }

    render() {
        const { t } = this.props;
        const positionContainer = this.state.displayAbout ? ["slideToLeft"] : ["col-xl-4 col-lg-5 col-md-6 col-sm-8 col-xs-12 mColumn"]
        const { isAvailable, linked, name, size, sizeBytes, status, token, userEmail, userFname, userLname, userExternalEmail, whitemarkBackground, whitemarkBtnColor, whitemarkFavicon, whitemarkLogo, whitemarkTitle } = this.state;

        if (null === status) {
            return (
                <div className="loader-wrapper" id="loader-wrapper">
                    <img src={lockGrey} alt="Cadenas : chargement" />
                    <div id="loader" />
                    <div className="loader-section-transparent section-left" />
                    <div className="loader-section-transparent section-right" />
                </div>
            )
        }

        if (this.state.badBrowser) {
            return <BadBrowser whitemarkTitle={whitemarkTitle} whitemarkFavicon={whitemarkFavicon} whitemarkBackground={whitemarkBackground} whitemarkBtnColor={whitemarkBtnColor} whitemarkLogo={whitemarkLogo} />
        }

        if (status === 404) {
            return <FileNotFound whitemarkTitle={whitemarkTitle} whitemarkFavicon={whitemarkFavicon} whitemarkBackground={whitemarkBackground} whitemarkLogo={whitemarkLogo} />
        }

        if (status === 403) {
            return <UserNotFound whitemarkTitle={whitemarkTitle} whitemarkFavicon={whitemarkFavicon} whitemarkBackground={whitemarkBackground} whitemarkLogo={whitemarkLogo} />
        }

        if (status === 204) {
            return <EmailProtectFragment
                isAvailable={isAvailable}
                transferHash1={this.state.transferHash1}
                transferHash2={this.state.transferHash2}
                userHash1={this.state.userHash1}
                userHash2={this.state.userHash2}
                linked={linked}
                name={name}
                userFname={userFname}
                userLname={userLname}
                userEmail={userEmail}
                userExternalEmail={userExternalEmail}
                size={size}
                sizeBytes={sizeBytes}
                status={status}
                token={token}
                whitemarkFavicon={whitemarkFavicon}
                whitemarkBackground={whitemarkBackground}
                whitemarkBtnColor={whitemarkBtnColor}
                whitemarkLogo={whitemarkLogo}
                whitemarkTitle={whitemarkTitle}
                transferLinked={this.state.linked}
                id={this.state.id}
            />
        }

        return (
            <div className="main">
                <Helmet>
                    <title>{whitemarkTitle}</title>
                    {<link rel="shortcut icon" href={whitemarkFavicon} />}
                    <style type="text/css">
                        {`
                                        .main {
                                            background:url(${whitemarkBackground});
                                            background-size:cover; 
                                        }
        
                                        .main>div.darker{
                                            background-color: rgba(32,32,48,0.7);
                                            min-height: 100vh;
                                        }
        
                                        button.orangeBtn {
                                            background-color: ${whitemarkBtnColor};
                                        }

                                        .logoPrincipal {
                                            background-image: url(${whitemarkLogo});
                                        }
                                    `}
                    </style>
                </Helmet>
                <div className="noDark">
                    <div className="container">
                        <div className="row">
                            <div className={positionContainer}>
                                <div className="logoPrincipal">&nbsp;</div>
                                <div className="rowContainer">
                                    <div className='senderContainer'>
                                        <h3 className="senderLabel">{t("general.sender")}</h3>
                                        <div className="Card sender">
                                            <span>{userFname.charAt(0) + userLname.charAt(0)}</span>
                                            <span>
                                                <h1>{userFname + " " + userLname}</h1>
                                                <h3>{userEmail}</h3>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="shareLabel">
                                        <h2>{t("general.title")}</h2>
                                    </div>

                                    <div className="Central">
                                        <div className="Card tokenVs">

                                            {linked?.length ?
                                                <div className="mfMapFrame">
                                                    <b className="title">
                                                        {linked.length+1} {t("general.files")}
                                                    </b>

                                                    <div className="mfMap">
                                                        <div>
                                                            <div>
                                                                <i className={checkFileType(name)}></i>
                                                                <b>{name}</b>
                                                            </div>
                                                            <span>{size}</span>
                                                        </div>

                                                        {linked.map((f,fi) => (
                                                            <div key={fi}>
                                                                <div>
                                                                    <i className={checkFileType(f.name)}></i>
                                                                    <b>{f.name}</b>
                                                                </div>
                                                                <span>{f.size}</span>
                                                            </div>
                                                        ))}
                                                    </div>

                                                </div>
                                                :
                                                <>
                                                    <div className="file-type">
                                                        <i className={checkFileType(name)}></i>
                                                    </div>
                                                    <div className="singleFile">
                                                        <span>
                                                            <h2>{name}</h2>
                                                            <div className="transferSize">
                                                                <span className="grey_pill">{size}</span>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </>
                                            }

                                            <button id="orangeBtn" className="orangeBtn" onClick={e => { document.getElementById("orangeBtn").setAttribute("disabled", "disabled"); this.generateToken() }}>{t("email.receiveToken")}</button>
                                            <p className="onEmail"><i>{t("general.on")} {this.state.userExternalEmail}</i></p>
                                        </div>
                                        <div className="shareId">
                                            <span>#{token}</span>
                                        </div>
                                    </div>
                                </div>
                                <Footer />
                            </div>
                        </div>
                        <RightSide transferIsAvailable={true} />
                    </div>
                </div>
            </div>
        )
    }

}

export default withTranslation()(EmailProtectFragmentStart)
